import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export default function ControllableStates(props) {
    const [selectedCode, setSelected] = useState(null);

    const emptyPlzObject = () => {
      return {
        id: '',
        plz: '', 
        stadt: '', 
        bundesland: '',
        landkreis: ''
      }
    }

    return (
      <Autocomplete
        id="PLZ"
        options={props.plzVorschlagsliste}
        popupIcon={props.data.value.length > 0 ? <ArrowDropDownIcon /> : null}
        noOptionsText={'Bitte geben Sie eine Zahl ein.'}
        renderInput={params => (
          <TextField 
            {...params} 
            name="postal-code"
            label={props.label} 
            required={props.required}
            error={errorState(props)}
            helperText={helperText(props)}
          />
        )}
        renderOption={(props, option) => {
            return (
                <ListItem {...props} key={option.id}>
                    <ListItemText
                        primary={option.plz}
                        secondary={option.stadt}
                    />
                </ListItem>
              );
        }}
        getOptionLabel={
            option => option.plz
        }
        isOptionEqualToValue={()=>{return true;}}
        value={selectedCode}
        onChange = {
            (_event, countryObject) => {
                let country = countryObject
                if (!country) {
                  country = emptyPlzObject()
                }
                setSelected(countryObject);
                props.updaterOrt(country.stadt)
            }
        }
        onBlur = {
          () => props.updaterTouch(true)
        }
        onInputChange = {
            (_event, value) => {
                props.updaterValueTextInput(value)
                props.updaterPlzVorschlagsliste(value)
                let plzobj = emptyPlzObject()
                plzobj.id = "manual_input_"+value
                plzobj.plz = value
                setSelected(plzobj);
            }
        }
      />
    );
}

const errorState = (props) => {
  let errMsg = helperText(props)
  if (errMsg.length < 1) {
    return false;
  }
  return true;
}

const helperText = (props) => {
  let msg = props.validator().message;

  if ( !props.data.hasOwnProperty("touched") ) {
    return msg;
  }

  if ( props.data.touched ) {
    return msg;
  }

  return [];
}

